import { createSelector } from 'reselect';
import { sortBy } from 'lodash';
import { getActiveDetailedInformationTab } from '../../selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { apiCallStatus } from 'helpers/constants';

const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

const getSelectedScatterKPIData = ({ operationalParameters }) => {
    return operationalParameters?.scatterV2?.data;
};

const getScatterDataAndConfig = createSelector([
    getSelectedScatterKPIData
],
    (data,) => {
        return data?.length ?
            {
                scatterData: data[0].values,
                scatterDataConfiguration: data[0].config
            }
            : {
                scatterData: [],
                scatterDataConfiguration: null
            };
    });

const getScatterLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.scatterV2?.loadingStatus;
};

const getScatterKpisData = ({ operationalParameters }) => {
    const kpis = operationalParameters?.scatterV2Kpis?.data;
    return sortBy(kpis, kpi => kpi.name?.toLowerCase());
};

const getScatterKpisLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.scatterV2Kpis?.loadingStatus;
};

const getSelectedKpi = ({ operationalParameters }) => {
    return operationalParameters?.selectedScatterV2KPI;
};

const getRawScatterErrorData = ({ operationalParameters }) => {
    if (operationalParameters?.scatterV2Kpis?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.scatterV2Kpis.loadingStatus,
            error: operationalParameters.scatterV2Kpis.error,
            errorCode: operationalParameters.scatterV2Kpis.error?.statusCode,
        };
    }
    if (operationalParameters?.scatterV2?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.scatterV2.loadingStatus,
            error: operationalParameters.scatterV2.error,
            errorCode: operationalParameters.scatterV2.error?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.scatterV2?.loadingStatus };
};

const getScatterErrorData = createErrorDataSelector(getRawScatterErrorData);

export const getModel = createSelector([
    getActiveDetailedInformationTab,
    getDateSelection,
    getScatterDataAndConfig,
    getScatterLoadingStatus,
    getScatterKpisData,
    getScatterKpisLoadingStatus,
    getSelectedKpi,
    getScatterErrorData,
],
    (
        activeDetailedInformationTab,
        dateSelection,
        scatterDataAndConfiguration,
        scatterDataLoadingStatus,
        scatterKpis,
        scatterKpisLoadingStatus,
        selectedKpi,
        errorData,
    ) => {
        return {
            activeDetailedInformationTab,
            dateSelection,
            ...scatterDataAndConfiguration,
            scatterDataLoadingStatus,
            scatterKpis,
            scatterKpisLoadingStatus,
            selectedKpi,
            errorData,
        };
    });
